import React from "react";

function Footer() {
  return (
    <div className="bg-white pt-4">
      <footer className="mx-auto max-w-screen-2xl border-t px-4 pt-6 sm:pb-2 md:px-8">
        <div className="flex flex-col items-center justify-center sm:flex-row sm:justify-between">
          <div className="mb-3 flex items-center justify-center gap-4">
            <a
              className="text-gray-400 transition duration-100 hover:text-gray-500 active:text-gray-600"
              target="_blank"
              title="Instagram"
              href="https://www.instagram.com/adithyana2005/"
              rel="noreferrer"
            >
              <svg
                className="h-5 w-5"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>

            <a
              className="text-gray-400 transition duration-100 hover:text-gray-500 active:text-gray-600"
              title="Github"
              target="_blank"
              href="https://github.com/AdithyanA2005/"
              rel="noreferrer"
            >
              <svg
                className="h-5 w-5"
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
              </svg>
            </a>

            <a
              className="text-gray-400 transition duration-100 hover:text-gray-500 active:text-gray-600"
              target="_blank"
              title="Mail"
              href="mailto:deepaadithyan56@gmail.com"
              rel="noreferrer"
            >
              <svg
                className="h-[1.37rem] w-auto"
                width="24"
                height="24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
              </svg>
            </a>
          </div>
          <div className="mb-3 flex items-center">
            <span className="text-sm text-gray-400">
              © 2022 - Present Centerio. All rights reserved.
            </span>
          </div>
        </div>
        <div className="mb-3 flex items-center justify-center sm:justify-start">
          <a
            className="text-sm text-gray-400 transition duration-100 hover:text-gray-500 active:text-gray-600"
            target="_blank"
            title=" Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc."
            href="http://fontawesome.com"
            rel="noreferrer"
          >
            Special Thanks To Fontawesome
          </a>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
